require('../../styles/ai/upload_pdf.scss');

const svgIcons = require('../icons/svg_icons');

module.exports = `
  <div class="ai-upload">
    <div class="logos-wrapper">
      <i class="dimensions-logo"></i>
      <i>${svgIcons.arrow_right}</i>
      <i>${svgIcons.readcube}</i>
    </div>
    <p class="text-wrapper-4">Upload PDF to use AI</p>
    <p class="text-wrapper-5">
      Chat with PDF is brought to you by an integration between Dimensions and Papers. To view the full PDF and chat using AI, upload the original document from the publisher.
    </p>
    <div class="div-8">
      <div class="div-9">
        <p class="div-10">
          <span class="span">Step 1:</span> <span class="text-wrapper-6"> Download from publisher</span>
        </p>
        <button id="goto-publisher">
          <div class="button-text">Go to Publisher</div>
          <div class="icon-wrapper">
            <i class="img">${svgIcons.linkout}</i>
          </div>
        </button>
      </div>
      <div id="drop-area">
        <p class="div-10">
          <span class="span">Step 2:</span> <span class="text-wrapper-6"> Upload downloaded PDF</span>
        </p>
        <button id="upload-pdf">
          <div class="icon-wrapper">
            <i class="vector-2">${svgIcons.upload}</i>
          </div>
          <div class="button-text">Upload PDF</div>
        </button>
        <input type="file" id="file-elem" accept="application/pdf" class="hidden">
      </div>
    </div>
  </div>
`;
